import React from 'react';
import DonationNote from '../DonationNote';
import { useReveal } from '../../hooks/useReveal';
import '../../styles/Help.css';

export interface DonationDetails {
  iban: string;
  ibanHolder: string;
  mbway: string;
  mbwayMessage: string;
}

interface HelpProps {
  donation?: DonationDetails;
}

const DEFAULT_DONATION: DonationDetails = {
  iban: 'PT50 0045 1371 4026 1082 5454 1',
  ibanHolder: 'Titular: Associação Patinhas Sem Lar — Silvalde, Espinho.',
  mbway: '933 843 593 · 938 465 633',
  mbwayMessage: 'mensagem: "PSL · o teu nome"',
};

const Help: React.FC<HelpProps> = ({ donation = DEFAULT_DONATION }) => {
  const { ref, revealed } = useReveal<HTMLElement>();
  return (
  <section
    ref={ref}
    className={`help psl-reveal${revealed ? ' is-in-view' : ''}`}
    id="help"
  >
    <div className="help__pattern" aria-hidden="true" />
    <div className="help__inner">
      <div className="help__chapter">Cap. III · Como ajudar</div>
      <h2 className="help__head">
        Uma coleira, um saco de ração,<br />
        uma consulta <em>— tudo conta.</em><br />
        <span className="help__hand">&amp; obrigada, a sério.</span>
      </h2>

      <p className="help__intro">
        Vivemos de doações. Cada contributo vai direto para medicamentos, vacinas,
        ração e pequenas obras no abrigo. Se preferires ajudar com tempo,{' '}
        <strong>temos sempre falta de famílias de acolhimento temporário</strong>.
      </p>

      <div className="help__notes">
        <DonationNote
          kind="— transferência · IBAN"
          title="IBAN"
          figures={donation.iban}
          caption={donation.ibanHolder}
          handNote="— qualquer valor ajuda."
          tapeColor="sage"
          tapeSide="left"
          rotation={-1.25}
          copyValue={donation.iban}
        />
        <DonationNote
          kind="— MB Way"
          title={donation.mbway}
          figures={donation.mbwayMessage}
          caption="Rápido, seguro. Assim sabemos a quem agradecer."
          handNote="— bonito, não é?"
          tapeColor="terracotta"
          tapeSide="right"
          rotation={0.75}
          copyValue={donation.mbway}
        />
      </div>

      <p className="help__small-print">
        Também aceitamos ração, antibióticos (prazo &gt; 6 meses) e coleiras novas — deixa no portão.
      </p>
    </div>
  </section>
  );
};

export default Help;
